/**
 * mobile-tap-fix.js
 * Fixes iOS Safari "first two taps dead" bug on collection page product cards.
 *
 * Root cause: The .pgi-mobile swipeable image track uses overflow-x:scroll,
 * which causes iOS to consume the first two taps for scroll-intent detection
 * before firing a click on the <a> tag inside.
 *
 * Fix: <a> tags are removed from the scroll container in product-grid.liquid.
 * Navigation is handled here via touchend detection with a tap-vs-swipe guard.
 *
 * Also initialises on DOMContentLoaded so it covers both initial page load
 * and any products injected by infinite scroll (document-level listeners).
 */

function initMobilePgiTap() {
  if (window.mobilePgiTapInitialized) return;
  window.mobilePgiTapInitialized = true;

  var _startX = 0;
  var _startY = 0;
  var _dragging = false;

  document.addEventListener('touchstart', function(e) {
    if (!e.target.closest('.pgi-mobile')) return;
    _startX = e.touches[0].clientX;
    _startY = e.touches[0].clientY;
    _dragging = false;
  }, { passive: true });

  document.addEventListener('touchmove', function(e) {
    if (!e.target.closest('.pgi-mobile')) return;
    var dx = Math.abs(e.touches[0].clientX - _startX);
    var dy = Math.abs(e.touches[0].clientY - _startY);
    if (dx > 8 || dy > 8) {
      _dragging = true;
    }
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    var pgi = e.target.closest('.pgi-mobile');
    if (!pgi) return;
    if (!_dragging) {
      var url = pgi.getAttribute('data-product-url');
      if (url) {
        window.location.href = url;
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initMobilePgiTap);
